import { Factory } from 'rosie';

Factory.define('RelationshipLabel').attr('name', 'RELATIONSHIP_LABEL');

Factory.define('RelationshipLabelWithDefaults')
  .extend('RelationshipLabel')
  .attr('id', 'default-id')
  .attr('displayName', 'default-name');



// WEBPACK FOOTER //
// ./factories/relationship_label_factory.js